import { Message, Loading, MessageBox } from "element-ui";
import store from "../store";
import service from "@/utils/service";

let loading,
  messageExport = null;
export default {
  install(Vue, options) {
    /********** 全局公用方法 **********/
    /**
     * @Description:  Boolean 判断
     * @param:
     * @Author: ZhangBin
     * @Date 2019-05-28 16:39
     */
    Vue.prototype.isTrue = v => {
      return v === true;
    };
    Vue.prototype.isFalse = v => {
      return v === false;
    };
    /**
     * @Description: Convert an input value to a number for persistence.If the conversion fails, return original string.
     * @param:
     * @Author: ZhangBin
     * @Date 2019-05-28 16:41
     */
    Vue.prototype.toNumber = val => {
      var n = parseFloat(val);
      return isNaN(n) ? val : n;
    };
    /**
     * @Description:  强制转换两位小数（正数）
     * @param:  val: 需要转换的值
     * @Author: ZhangBin
     * @Date
     */
    Vue.prototype.toDecimal = val => {
      if (isNaN(parseFloat(val)) || isNaN(val)) {
        return "";
      }
      let f = Math.round(val * 100) / 100;
      let s = f.toString();
      let rs = s.indexOf(".");
      if (rs < 0) {
        rs = s.length;
        s += ".";
      }
      while (s.length <= rs + 2) {
        s += "0";
      }
      return s;
    };
    /**
     * @Description:  数字验证（小数，非负数）
     * @param:
     * @Author: ZhangBin
     * @Date 2018/12/6 上午11:19
     */
    Vue.prototype.checkDecimalNumber = val => {
      if (isNaN(parseFloat(val)) || isNaN(val)) {
        Message({
          message: "请输入数字！",
          type: "error",
          duration: 2000
        });
        return "";
      } else if (/^[-]\d+[.]?\d*$/.test(val)) {
        Message({
          message: "请输入正数！",
          type: "error",
          duration: 2000
        });
        return "";
      } else {
        return val;
      }
    };
    /**
     * @Description:  数字验证（正整数）
     * @param:
     * @Author: ZhangBin
     * @Date 2018/12/6 上午11:19
     */
    Vue.prototype.checkInteger = val => {
      if (val !== "") {
        let re = /^[0-9]+$/;
        if (!re.test(val)) {
          Message({
            message: "请输入正整数！",
            type: "error",
            duration: 2000
          });
          return "";
        } else {
          return val;
        }
      }
    };
    /**
     * @Description:  千分位格式化并保留两位小数
     * @param:
     * @Author: ZhangBin
     * @Date 2018/12/10 下午8:01
     */
    Vue.prototype.thousandsDecimalNumber = (val, flag = true) => {
      if (isNaN(parseFloat(val)) || isNaN(val)) return "0";
      let num;
      if (flag) {
        num = String(val.toFixed(2));
      } else {
        num = String(val);
      }
      let reg = /(-?\d+)(\d{3})/;
      while (reg.test(num)) {
        num = num.replace(reg, "$1,$2");
      }
      return num;
    };
    /**
     * @Description: 根据classname获取元素
     * @param:  classname: class名
     * @Author: ZhangBin
     * @Date
     */
    Vue.prototype.getEleByClass = classname => {
      var tags = document.all
        ? document.all
        : document.getElementsByTagName("*");
      var arr = [];
      // var reg = /\bclassname\b/g;//普通方式定义
      var reg = new RegExp("\\b" + classname + "\\b", "g"); //构造函数方式
      for (var i = 0; i < tags.length; i++) {
        reg.lastIndex = 0;
        if (reg.test(tags[i].className)) {
          arr.push(tags[i]);
        }
      }
      return arr;
    };
    /**
     * @Description:  !==null 且 !== undefined 且 !== ''
     * @param:
     * @Author: ZhangBin
     * @Date 2019-12-10 14:46
     */
    Vue.prototype.isAbsoluteTrue = val => {
      return val !== "" && val !== undefined && val !== null;
    };
    /**
     * @Description:  判断数据是否为字符串null
     * @param:
     * @Author: ZhangBin
     * @Date 2018/12/6 下午8:49
     */
    Vue.prototype.checkIsStrNull = val => {
      if (val == "null" || val == null) {
        return "";
      } else {
        return val;
      }
    };
    /**
     * @Description:  判断数组是否为空
     * @param:
     * @Author: ZhangBin
     * @Date 2019-10-12 14:14
     */
    Vue.prototype.isEmptyArray = arr => {
      if (Object.prototype.toString.call(arr) === "[object Array]") {
        return arr.length === 0;
      } else {
        throw new Error("The argument must be an array");
      }
    };
    /**
     * @Description:  判断对象是否为空
     * @param:
     * @Author: ZhangBin
     * @Date 2019-10-11 14:32
     */
    Vue.prototype.isEmptyObject = obj => {
      try {
        return Object.keys(obj).length === 0;
      } catch (e) {
        throw new Error("The argument must be an object");
      }
    };
    /**
     * @Description:  判断对象是否有某个属性
     * @param: obj [Object] key [String]
     * @Author: ZhangBin
     * @Date 2019-11-14 14:22
     */
    Vue.prototype.hasOwn = (obj, key) => {
      let hasOwnProperty = Object.prototype.hasOwnProperty;
      return hasOwnProperty.call(obj, key);
    };
    /**
     * @Description:  控制台输出信息
     * @param:
     * @Author: ZhangBin
     * @Date 2018/12/7 上午11:29
     */
    Vue.prototype.log = message => {
      console.log("%o", message);
    };

    Vue.prototype.error = message => {
      console.error(
        "%c" + message + "",
        "background:#F00; color:#FFFFFF; font-size: 14px;"
      );
    };
    /**
     * @Description: 加载loading效果
     * @param:
     * @Author: ZhangBin
     * @Date 2018/12/10 下午1:51
     */
    Vue.prototype.loading = (
      target = document.getElementById("elMain"),
      text = "加载中……"
    ) => {
      loading = Loading.service({
        target: document.getElementById("elMain"),
        lock: true,
        text: text,
        background: "rgba(255, 255, 255, 0.6)",
        spinner: "loading_icon iconfont icon-loading"
      });
    };
    Vue.prototype.closeLoading = () => {
      loading.close();
    };
    /**
     * @Description:  confirm 弹窗二次封装
     * @param:
     * @Author: ZhangBin
     * @Date 2019-04-12 09:33
     */
    // 调用 this.$confirmMsg().then(() => {删除}).catch(() => {取消})
    Vue.prototype.$confirmMsg = (
      msg = "是否删除?",
      title = "提示",
      type = "warning"
    ) => {
      return new Promise((resolve, reject) => {
        MessageBox.confirm(msg, title, {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: type
        })
          .then(() => {
            resolve();
          })
          .catch(() => {
            reject();
          });
      });
    };
    /**
     * @Description:  生成uuid
     * @param:
     * @Author: ZhangBin
     * @Date 2018/12/29 上午11:00
     */
    Vue.prototype.createUuid = () => {
      let s = [];
      let hexDigits = "0123456789abcdef";
      for (let i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
      }
      s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
      s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01

      let uuid = s.join("");
      return uuid;
    };
    /**
     * @Description:  导出Excel, 下载文件
     * @param:
     * @Author: CQH
     * @Date 2019-04-12 16:40
     */
    // 将json转换成params请求参数
    let urlEncode = function(param, key, encode) {
      if (param == null) return "";
      let paramStr = "";
      let t = typeof param;
      if (t == "string" || t == "number" || t == "boolean") {
        paramStr +=
          "&" +
          key +
          "=" +
          (encode == null || encode ? encodeURIComponent(param) : param);
      } else {
        for (let i in param) {
          let k =
            key == null
              ? i
              : key + (param instanceof Array ? "[" + i + "]" : "." + i);
          paramStr += urlEncode(param[i], k, encode);
        }
      }
      return paramStr;
    };
    Vue.prototype.exportExcel = (url, params) => {
      // 先请求接口、成功则下载
      if (messageExport) {
        messageExport.close();
      }
      messageExport = Message({
        message: "导出中",
        duration: 0
      });
      params.userId = store.getters.userId;
      service({
        url: url,
        methods: "get",
        params: params
      })
        .then(res => {
          if (res.status == 200) {
            // 创建下载链接
            let eleLink = document.createElement("a");
            eleLink.style.display = "none";
            eleLink.href =
              window.globalConfig.exportExcelUrl +
              url +
              "?" +
              urlEncode(params).substr(1);

            eleLink.setAttribute("download", "");
            eleLink.setAttribute("target", "_blank");
            // 触发点击
            document.body.appendChild(eleLink);
            eleLink.click();
            // 移除
            document.body.removeChild(eleLink);
            messageExport.close();
          } else {
            messageExport.close();
            Message({
              message: "导出失败，请稍后重试！",
              type: "warning",
              duration: 2000
            });
          }
        })
        .catch(err => {
          messageExport.close();
          console.log(err);
        });
    };
    Vue.prototype.downloadFile = (url, params) => {
      // 创建下载链接
      let eleLink = document.createElement("a");
      eleLink.style.display = "none";
      eleLink.href =
        url.startsWith("http:") || url.startsWith("https:")
          ? url
          : window.globalConfig.downloadUrl +
            url +
            "?" +
            urlEncode(params).substr(1);

      eleLink.setAttribute("download", "");
      eleLink.setAttribute("target", "_blank");
      // 触发点击
      document.body.appendChild(eleLink);
      eleLink.click();
      // 移除
      document.body.removeChild(eleLink);
    };

    /**
     * @Description:  Convert a value to a string that is actually rendered.
     * @param:
     * @Author: ZhangBin
     * @Date 2019-05-28 16:24
     */
    Vue.prototype.convertToString = val => {
      return val == null
        ? ""
        : typeof val === "object"
        ? JSON.stringify(val, null, 2)
        : String(val);
    };
    /**
     * @Description:  匹配字符串中img标签并返回src数组
     * @param:
     * @Author: ZhangBin
     * @Date 2019-11-02 16:33
     */
    Vue.prototype.matchImgElement = str => {
      let imgReg = /<img.*?(?:>|\/>)/gi,
        srcReg = /src=[\'\"]?([^\'\"]*)[\'\"]?/i,
        imgSrcArr = [],
        arr = str.match(imgReg); // arr 为包含所有img标签的数组
      if (!arr) {
        Message({
          message: "没有匹配到图片！",
          type: "warning",
          duration: 2000
        });
        return [];
      }
      for (var i = 0; i < arr.length; i++) {
        let src = arr[i].match(srcReg);
        //获取图片地址
        imgSrcArr.push(src[1]);
      }
      return imgSrcArr;
    };
    /********** END **********/
    /**
     * @Description:  模板编译函数
     * @param:
     * @Author: ZhangBin
     * @Date 2020-03-19 15:18
     * @Example 模板: `<ul><% for(let i=0; i < data.length; i++) { %><li><%= data[i] %></li><% } %></ul>`;
     *          调用：eval(this.templateCompile(template))(data)
     */
    Vue.prototype.templateCompile = template => {
      const evalExpr = /<%=(.+?)%>/g;
      const expr = /<%([\s\S]+?)%>/g;

      template = template
        .replace(evalExpr, "`); \n  echo( $1 ); \n  echo(`")
        .replace(expr, "`); \n $1 \n  echo(`");

      template = "echo(`" + template + "`);";

      return `(function parse(data){
          let output = "";

          function echo(html){
            output += html;
          }

          ${template}

          return output;
        })`;
    };
    /********** END **********/
    /**
     * @Description:  创建对象，键值为''
     * @param:
     * @Author: ZhangBin
     * @Date 2020-03-26 15:33
     */
    Vue.prototype.setProps = (obj, prop) => {
      let _this = new Vue();
      let tempObj = Object.assign({}, obj); // 不修改源对象
      try {
        if (_this.isAbsoluteTrue(prop) && !_this.isEmptyArray(prop)) {
          // 多个prop
          for (let i = 0, len = prop.length; i < len; i++) {
            let item = prop[i];
            Reflect.set(tempObj, item, "");
          }
        } else {
          Reflect.set(tempObj, prop, "");
        }
        return tempObj;
      } catch (e) {
        throw new Error(e);
      }
    };
    /********** END **********/

    /**
     * @Description: 冒泡排序
     * @Params: arr:Array 原数组、fn：Function 升降序函数、key:String 排序的键值（非必选）
     * @Return:
     * @Author: BEN
     * @Date: 2021/2/26 9:37
     */
    Vue.prototype.bubbleSort = (arr, fn, key = "") => {
      let len = arr.length;
      while (len--) {
        for (let i = 0; i < len; i++) {
          if (key !== "") {
            if (fn(arr[i][key], arr[i + 1][key]) > 0) {
              [arr[i], arr[i + 1]] = [arr[i + 1], arr[i]];
            }
          } else {
            if (fn(arr[i], arr[i + 1]) > 0) {
              [arr[i], arr[i + 1]] = [arr[i + 1], arr[i]];
            }
          }
        }
      }
      return arr;
    };
    // 获取屏幕宽度
    Vue.prototype.screenWidth = () => {
      let a = window.screen.width;
      if (a < 800) {
        return true;
      } else {
        return false;
      }
    };
  }
};



// WEBPACK FOOTER //
// ./src/utils/utils.js